import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { useScrollCarouselItem } from 'dibs-scroll-carousel/exports/useScrollCarouselItem';
import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import { Spinner } from 'dibs-elements/exports/Spinner';

const PdpSharedVideoVimeoLazy = dibsLazyClient(() =>
    import(
        /* webpackChunkName: "PdpSharedVideoVimeo" */ '../../../shared/PdpSharedVimeoVideo/PdpSharedVimeoVideo'
    ).then(mod => ({ default: mod.PdpSharedVideoVimeo }))
);

import { VimeoVideo_videoVimeo$key } from './__generated__/VimeoVideo_videoVimeo.graphql';

import styles from './VimeoVideo.scss';

const videoVimeoFragment = graphql`
    fragment VimeoVideo_videoVimeo on VideoVimeo {
        vimeoId
    }
`;

const Loading: FC = () => (
    <>
        <Spinner dark size="small" />
        <span className={styles.text}>
            <FormattedMessage id="VimeoVideo.loadingVideo" defaultMessage="Video Loading" />
        </span>
    </>
);

export const VimeoVideo: FC<{
    videoVimeo: VimeoVideo_videoVimeo$key;
}> = ({ videoVimeo }) => {
    const videoVimeoData = useFragment(videoVimeoFragment, videoVimeo);
    const { isActive } = useScrollCarouselItem();

    const id = videoVimeoData.vimeoId && parseInt(videoVimeoData.vimeoId);

    return id ? (
        <ClientSuspense fallback={<Loading />}>
            <PdpSharedVideoVimeoLazy id={id} isActive={isActive} />
        </ClientSuspense>
    ) : (
        <Loading />
    );
};
